/**
 * Pre-compiled fr-FR messages for Toast
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { dismiss: `Fermer` };
